import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { ClientService } from './client.service';
import { CourseService } from './course.service';
import { UnitService } from './unit.service';
import { LessonService } from './lesson.service';
import { ActivityService } from './activity.service';
import { ContentService } from './content.service';
import { CognitoService } from './cognito.service';
import { SectionService } from './section.service';
import { LocationService } from './location.service';
import { ReportingService } from './reporting.service';
import { AuthService } from './auth.service';
import { JourneyReports } from './journey-reports';
import { StrideReports } from './stride-reports';
import { AdminService } from './admin.service';

@Injectable({
	providedIn: 'root',
})
export class Loading {
	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private sub: Subscription | undefined;

	constructor(
		private authService: AuthService,
		private cognitoService: CognitoService,
		private adminService: AdminService,
		private clientService: ClientService,
		private locationService: LocationService,
		private sectionService: SectionService,
		private courseService: CourseService,
		private unitService: UnitService,
		private lessonService: LessonService,
		private activityService: ActivityService,
		private contentService: ContentService,
		private reportingService: ReportingService,
		private journeyReportingService: JourneyReports,
		private strideReportsService: StrideReports
	) {
		this.initializeLoadingState();
	}

	private initializeLoadingState(): void {
		this.sub = combineLatest([
			this.authService.loading$,
			this.cognitoService.loading$,
			this.adminService.loading$,
			this.clientService.loading$,
			this.locationService.loading$,
			this.sectionService.loading$,
			this.courseService.loading$,
			this.unitService.loading$,
			this.lessonService.loading$,
			this.activityService.loading$,
			this.contentService.loading$,
			this.reportingService.loading$,
			this.journeyReportingService.loading$,
			this.strideReportsService.loading$,
		]).subscribe(loadingStates => {
			const isLoading = loadingStates.some(state => state);
			this.loading$.next(isLoading);
		});
	}

	ngOnDestroy(): void {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
}
